export default {
  sort: 1,
  name:"NewOrderEdit",
  path:"/NewOrderEdit",
  component: () => import('@/views/newEditOrder/NewEditOrder.vue')

}



// WEBPACK FOOTER //
// ./src/router/modules/newOrderEdit.js